export default ({ credit, notification, parkingHistory }) => {
  let timeline = [];

  const mappedCredit = mapCredit(credit);
  const mappedNotification = mapNotification(notification);
  const mappedParkingHistory = mapParkingHistory(parkingHistory);

  timeline.push(...mappedCredit);
  timeline.push(...mappedNotification);
  timeline.push(...mappedParkingHistory);

  // const sorrtedTimeline = timeline.sort((a, b) => new Date(a.timelineMoment) < new Date(b.timelineMoment) ? -1 : 1 )
  const grouppedTimeline = groupTimeline(timeline);
  const sortedGrouppedTimeline = sortGroupTimeline(grouppedTimeline);
  return sortedGrouppedTimeline;
};

const mapCredit = credit => {
  return credit.map(item => {
    return {
      type: 'credit',
      paymentType: item.paymentType,
      timelineMoment: item.createdAt,
      amountPaid: item.amountPaid,
      settledAmountPaid: item.settledAmountPaid,
      employee: item.employee && item.employee.fullName,
      paymentDate: item.paymentDate,
      totalMinutes: item.totalMinutes,
      settled: item.settled,
      settledEmployee: item.settledEmployee
        ? item.settledEmployee.fullName
        : null,
      isReversed: item.isReversed,
      photos: item.vehiclePhotoPath,
      creditCode: item.creditCode
    };
  });
};

const mapNotification = notification => {
  return notification.map(item => {
    return {
      type: 'notification',
      timelineMoment: item.startDate,
      notifyCode: item.notifyCode,
      photoPath: item.vehiclePhotoPath,
    };
  });
};

const mapParkingHistory = parkingHistory => {
  return parkingHistory.map(item => {
    return {
      type: 'parkingHistory',
      timelineMoment: item.currentTime,
      employee: item.employee && item.employee.fullName,
      isParked: item.isParked,
      movement: item.movement,
      parking: item.parking.parkName,
    };
  });
};

const groupTimeline = timeline => {
  const grouppedTimeline = {};

  for (let item in timeline) {
    if (!grouppedTimeline[timeline[item].timelineMoment]) {
      grouppedTimeline[timeline[item].timelineMoment] = {};
    }

    grouppedTimeline[timeline[item].timelineMoment][timeline[item].type] =
      timeline[item];
  }

  return grouppedTimeline;
};

const sortGroupTimeline = timeline => {
  const sorted = Object.keys(timeline).sort((a, b) =>
    new Date(a) > new Date(b) ? -1 : 1,
  );
  const sortedGroup = {};
  for (let key in sorted) {
    sortedGroup[sorted[key]] = timeline[sorted[key]];
  }
  return sortedGroup;
};
